<template>
  <div v-if="isReviewsFound">
    <div class="tw-space-y-7">
      <div
        v-for="review in reviews"
        :key="review.id"
        class="tw-flex tw-flex-col tw-border-b tw-border-gray-300 tw-pb-7"
      >
        <FeedbackContainerItem :review="review" />
        <FeedbackContainerResponseItem
          v-if="review.response?.message && !review.is_moderated"
          :response="review.response"
        />
      </div>
    </div>

    <div class="tw-mt-5">
      <div class="tw-flex tw-justify-between">
        <a
          v-if="nextPageReviewsUrl"
          href
          @click.prevent="loadMoreReviews"
          :style="`color: ${$page.props.customisation.secondary_background}`"
          class="tw-w-full tw-text-blue-500 tw-transition tw-ease-in-out"
        >
          See more reviews...
        </a>

        <Footer :class="nextPageReviewsUrl ? 'tw-flex' : ''" />
      </div>
    </div>
  </div>
  <div v-else>
    <div class="tw-items-center tw-space-y-5 tw-text-center">
      <RatingStar class="tw-mx-auto tw-text-6xl tw-text-gray-200" />
      <div class="tw-text-xl tw-text-gray-600">No reviews to display</div>
      <div class="tw-text-gray-500">Try resetting your filters</div>
    </div>
  </div>
</template>

<script setup>
import Footer from '@Layout/Standalone/Blocks/Footer.vue';
import { computed } from 'vue';
import FeedbackContainerItem from './FeedbackContainerItem.vue';
import FeedbackContainerResponseItem from './FeedbackContainerResponseItem.vue';

const props = defineProps({
  reviews: Array,
  nextPageReviewsUrl: String,
});

const isReviewsFound = computed(() => props.reviews.length > 0);

const emit = defineEmits(['valueSelect']);

const loadMoreReviews = () => {
  emit('valueSelect');
};
</script>
